export const formatCurrency = (amount: number | undefined, currency: string = 'USD') => {
  if (amount === undefined) return '-';
  const locale = currency === "NGN" ? "en-NG" : "en-US";
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}; 